
import React from 'react';
import TrustIndicator from './TrustIndicator';
import { Shield, Award, Users } from 'lucide-react';

const TrustIndicators = () => {
  return (
    <div className="bg-muted rounded-xl p-8 shadow-sm">
      <h3 className="text-2xl font-bold mb-6 text-center">Why Clients Trust Us</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <TrustIndicator 
          icon={<Shield />}
          iconBgClass="bg-primary/10"
          iconClass="h-8 w-8 text-primary"
          title="Industry Certifications"
          description="ISO 9001:2015 certified with rigorous quality management standards. Also hold ISO 27001 for information security management."
        />
        
        <TrustIndicator 
          icon={<Award />}
          iconBgClass="bg-secondary/10"
          iconClass="h-8 w-8 text-secondary"
          title="Award-Winning Service"
          description="Recipient of multiple industry awards for innovation and customer service, including the 2023 Tech Excellence Award for Custom Hardware Solutions."
        />
        
        <TrustIndicator 
          icon={<Users />}
          iconBgClass="bg-accent/10"
          iconClass="h-8 w-8 text-accent"
          title="Expert Team"
          description="150+ hardware specialists with an average of 10+ years of industry experience. Continuous training ensures our team stays at the cutting edge."
        />
      </div>
    </div>
  );
};

export default TrustIndicators;
